module.exports = __webpack_public_path__ + "img/office-4.804cf3e2.jpg";